<template>
  <div class="editor-slider__pagination-count-wrapper">
    <div class="editor-slider__pagination-count">
      {{ current }}<span>/</span>{{ total }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  current: { type: Number, required: true },
  total: { type: Number, required: true },
});
</script>
